import { Expose } from 'class-transformer';

export class ClientInfoTherapyTitleDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
